﻿import React from "react";
import { useActivitiesData } from "./ActivitiesDataContext";

const WeeklyMonotonyTile = {
    fields: {
        label: { type: "text" as const },
        colorClass: { type: "text" as const },
    },
    defaultProps: {
        label: "Monotony",
        colorClass: "from-amber-500 to-amber-600",
    },
    inline: true,
    render: (props: any) => {
        const { label, colorClass, puck } = props as any;
        const { weekReport } = useActivitiesData();
        const value = (weekReport?.monotony ?? 0).toFixed(2);
        return (
            <div ref={puck.dragRef} className={`bg-gradient-to-br ${colorClass} rounded-lg p-5 text-white`}>
                <div className="text-2xl font-bold">{value}</div>
                <div className="text-amber-100">{label}</div>
            </div>
        );
    },
};

export default WeeklyMonotonyTile;


